export const WEB = "WEB";
export const LOG_FWD = "LOG_FWD";
export const C24 = "C24";
